import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import api from "../../Services/api"; 
import Header from "../../component/Header";
import Pagination from "../../component/Pagination";
import IconDelete from "../../component/SvgIcons/IconDelete";
import IconPen from "../../component/SvgIcons/IconPen";
import IconPlus from "../../component/SvgIcons/IconPlus";
import IconSearch from "../../component/SvgIcons/IconSearch";
import IconUpdownFilter from "../../component/SvgIcons/IconUpdownFilter";
import { useSwal } from "../../component/sweetalert";
import "./style.css";

import { formatCountryDate } from "../../Services/countryTime";
export default function Blog() {
  const alert = useSwal();
  const [blogs, setBlogs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [itemsPerPage, setItemsPerPage] = useState(10);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1920) {
        setItemsPerPage(20);
      } else {
        setItemsPerPage(10);
      }
    };
    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch blogs from API
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await api.post("/AllBlogView");
        const blogsdata = response.data.reverse();
        setBlogs(blogsdata);
        console.log("blog", response);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };
    fetchBlogs();
  }, []);

  // Search handler
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  // Sort handler
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  // Apply sorting
  const sortedBlogs = [...blogs].sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key])
      return sortConfig.direction === "asc" ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key])
      return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  // Apply filtering
  const filteredBlogs = sortedBlogs.filter((blog) => {
    const formattedDate = formatCountryDate(blog.date)
      .replace(/\//g, "-");

    return (
      formattedDate.includes(searchQuery) ||
      blog.heading.toLowerCase().includes(searchQuery.toLowerCase()) ||
      blog.content.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredBlogs.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // ✅ Delete Blog
  const handleDelete = async (id) => {
    const isConfirmed = await alert('warning', 'Do you really want to delete this blog?', 'Are you sure?', {
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    });
    if (!isConfirmed) return;
    try {
      await api.post(`/deleteblog/${id}`);
      setBlogs((prevBlogs) => prevBlogs.filter((blog) => blog.image_id !== id));
      alert('success', 'Blog deleted successfully.', "Deleted!");
    } catch (error) {
      console.error("Error deleting blog:", error);
      alert('error', 'An error occurred while deleting the blog.', 'Oops...');
    }
  };

  return (
    <section className="eventpage">
      <Header pageTitle="Blogs Details List" />
      <div className="pageLeftspace">
        <div className="d-flex justify-content-between align-items-center topsearchbar">
          <div className="d-flex align-items-center gap-2">
            <Link to="/add-blog" className="btn btn-purpal addbutton">
              <IconPlus />
              Add Blog
            </Link>
{/* 
<Link to="/add-hashtags" className="btn btn-purpal addbutton">
              <IconPlus />
              Add Hashtag
            </Link> */}

            <Link to="#" onClick={() => handleSort("date")}>
              <IconUpdownFilter />
            </Link>
          </div>

          <div className="input-container">
            <input
              type="text"
              id="search"
              placeholder="Search Here.."
              value={searchQuery}
              onChange={handleSearchChange}
            />
            {/* <label htmlFor="password">Search here..</label> */}
            <span className="underline"></span>
            <div className="search-icon">
              <IconSearch />
            </div>
          </div>
        </div>

        <div className="tableheader d-flex flex-column gap-4">

          <div className="event-detailstable">
            <table className="table">
              <thead>
                <tr>
                  <th width="10px" align="center">Sr. No.</th>
                  <th width="50px">
                    Date
                  </th>
                  <th width="300px">Blog Picture</th>
                  <th width="300px">
                    Blog Titles
                  </th>
                  <th >Blog Details</th>
                  <th >Blog Likes</th>
                  <th >Blog Hashtags</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentBlogs.length > 0 ? (
                  currentBlogs.map((blog, index) => (
                    <tr key={blog.image_id}>
                      <td align="center">{indexOfFirstItem + index + 1}</td>
                      <td>
                        {formatCountryDate(blog.date).replace(/\//g, "-")}
                      </td>
                      <td>
                        {/* 
                        {blog.image && (
                          <img
                            className="blog-image"
                            src={`${process.env.REACT_APP_API_PRJ_URL}${blog.image}`}

                            style={{ width: "50px", height: "auto" }}
                          />
                        )} */}


                        {Array.isArray(blog.image) && blog.image.length > 0 ? (
                          blog.image.map((imgUrl, idx) => {
                            const cleanPath = imgUrl
                              .replace(/^"|"$/g, "")
                              .replace(/^undefined/, "")
                              .replace(/^https?:\/\/[^/]+/, "")
                              .replace(/^\/uploads\/(?!blog\/)/, "/uploads/blog/");
                            return (
                              <img
                                key={idx}
                                className="blog-image me-2"
                                src={`${process.env.REACT_APP_API_PRJ_URL}${cleanPath}`}
                                alt={`blog-img-${idx}`}
                                style={{ width: "50px", height: "auto", borderRadius: "5px" }}
                              />
                            );
                          })
                        ) : (
                          <span>No Image</span>
                        )}



                      </td>
                      {/* <td>{blog.heading}</td> */}

                      <td>
                        {blog.heading.length > 20
                          ? `${blog.heading.substring(0, 50)}...`
                          : blog.heading}

                        {/* <Tooltip
                          id="blog-tooltip"
                          place="top"
                          effect="solid"
                          style={{ whiteSpace: "normal", maxWidth: "400px" }}
                        /> */}
                      </td>

                      <td
                        data-tooltip-id={`blog-tooltip-${blog.id}`}
                        data-tooltip-content={
                          blog.content
                            ? blog.content.replace(/<\/?[^>]+(>|$)/g, "")
                            : ""
                        }
                      >
                        {/* Text Preview */}
                        {blog.content
                          ? blog.content.replace(/<\/?[^>]+(>|$)/g, "").length > 20
                            ? `${blog.content.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 50)}...`
                            : blog.content.replace(/<\/?[^>]+(>|$)/g, "")
                          : ""}

                        {/* Image Preview */}

                        <div style={{ display: 'flex', gap: '6px', marginTop: '8px' }}>
  {[...(blog.content.replace(/src=""+/g, 'src="')).matchAll(/<img[^>]+src="([^">]+)"/g)].map(
    (match, index) => {
      const originalSrc = match[1];

      // Strip domain and use .env base instead
      const imagePath = originalSrc.replace(/^https?:\/\/[^/]+/, "");
      const adjustedSrc = `${process.env.REACT_APP_API_PRJ_URL}${imagePath}`;

      return (
        <img
          key={index}
          src={adjustedSrc}
          alt={`img-${index}`}
          width="50"
          height="50"
          style={{ objectFit: 'cover', borderRadius: '4px' }}
        />
      );
    }
  )}
</div>

                      </td>
   <td style={{ textAlign: 'center' }}>{blog.likes}</td>
                      <td>{blog.hashtags?.split(" ").filter(Boolean).slice(0, 5).join(" ")}</td>
                      <td>
                        <div className="action">
                          <Link
                            to={`/edit-blog/${blog.image_id}`}
                            className="editbtn"
                            data-tooltip-id={`edit-${blog.image_id}`}
                            data-tooltip-content="Edit"
                          >
                            <IconPen />
                          </Link>
                          <Tooltip id={`edit-${blog.image_id}`} place="top" />

                          <Link
                            to="#"
                            onClick={() => handleDelete(blog.image_id)}
                            data-tooltip-id={`delete-${blog.image_id}`}
                            data-tooltip-content="Delete"
                          >
                            <IconDelete />
                          </Link>
                          <Tooltip id={`delete-${blog.image_id}`} place="top" />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="9"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* Pagination */}
          <Pagination
            currentPage={currentPage}
            totalPages={filteredBlogs.length > itemsPerPage ? totalPages : 0}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </section>
  );
}
